
import type { StudyDeck } from '../types';
import { getAllDrugs } from './pharmacyService';

const getMissedCardsKey = (uid: string) => `drrx_missed_cards_${uid}`;
const getBookmarkedCardsKey = (uid: string) => `drrx_bookmarked_cards_${uid}`;


// --- Missed & Bookmarked Cards ---

const getArrayFromStorage = (key: string): string[] => {
    try {
        const stored = localStorage.getItem(key);
        return stored ? JSON.parse(stored) : [];
    } catch { 
        return []; 
    }
};

const setArrayInStorage = (key: string, array: string[]) => {
    localStorage.setItem(key, JSON.stringify(array));
};

export const getMissedCards = (uid: string): string[] => getArrayFromStorage(getMissedCardsKey(uid));

export const addMissedCard = (drugId: string, uid: string): void => {
    const missed = getMissedCards(uid);
    if (!missed.includes(drugId)) {
        setArrayInStorage(getMissedCardsKey(uid), [...missed, drugId]);
    }
};

export const removeMissedCard = (drugId: string, uid: string): void => {
    const missed = getMissedCards(uid);
    setArrayInStorage(getMissedCardsKey(uid), missed.filter(id => id !== drugId));
};

export const getBookmarkedCards = (uid: string): string[] => {
    return getArrayFromStorage(getBookmarkedCardsKey(uid));
};

export const isBookmarked = (drugId: string, uid: string): boolean => {
    return getBookmarkedCards(uid).includes(drugId);
};

export const toggleBookmark = (drugId: string, uid: string): void => {
    const bookmarks = getBookmarkedCards(uid);
    if (bookmarks.includes(drugId)) {
        setArrayInStorage(getBookmarkedCardsKey(uid), bookmarks.filter(id => id !== drugId));
    } else {
        setArrayInStorage(getBookmarkedCardsKey(uid), [...bookmarks, drugId]);
    }
};
